import React, { useState,useContext } from 'react'
import { PeFilterContext } from "../../../Contexts/PeFilterContext";
import Card from '../../../Components/Advisor/AdvisorPageCard/Card'
import Layout from '../../../Components/VC/VcTAdvisorLayout'
import MainMenu from '../../../Components/VC/AllTransactionMainmenu'
// import RefineSearch from '../../../Components/RefineSearch'
import Table from '../../../Components/TransactionAdvisor/AllT_TableComponent'
import FilterTag from '../../../Components/Tag'
import RefineSearch from '../../../Components/RefineSearchComponent'
import AdvisorExistsRefineSearch from '../../../Components/RefineSearch/AdvisorExistsRefineSearch'
import { PE_TABLE_QUERY } from '../../../Queries/Pe';
import ChatIcon from '../../../images/Group 13/png/Group 13.png';
import chatPopupIcon from '../../../images/chatPopupIcon.png'
import ChatPopup from '../../../Components/ChatPopup'
import Constants from '../../../Constants'
import { useLocation } from 'react-router-dom'

/* The `Advisor` function is a React component that renders the Advisor page. */
function Advisor() {
    const [showModal, setShowModal] = React.useState(false);
    const location = useLocation();

    const {refineSearchFilters,isMobile} = useContext(PeFilterContext);

    const { pathname } = useLocation(); 
      const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false

    return (
        <>
            <Layout active={4}>
                <div className="flex h-screen flex-col">
                    {/* Bottom section */}
                    <div className="flex min-h-0 flex-1 overflow-hidden">
                        {/* Narrow sidebar*/}
                        {/* Main area */}
                        <main className= {isFromGlobalSearch() ? "min-w-0 flex-1 border-t border-gray-200 flex":"min-w-0 mt-14 flex-1 border-t border-gray-200 flex"}>
                            {/* Primary column */}
                            <section
                                className="flex h-full min-w-0 flex-1 flex-col overflow-y-auto lg:order-last bg-[#EDEDED]"
                            >
                                <div></div>
                                <MainMenu type="vc_exit" active={2} menu="tadvisor" subMenu="vc-" primaryTypeMasterId={Constants.primaryMasterIds.vcId}
                                subTypeMasterId={Constants.primaryMasterSubIds.vc_advisors_exits_id}
                                typeId={Constants.moduleIds.t_advisor_id}
                                advisor_type="T"
                                exportFileName={Constants.exportNames.vc_t_advisor_exit}/>
                                <div className='overflow-y-auto'>
                                    <Table menu="vc_exit" advisor_type="T" sub_type_master_id={Constants.subCategoryIds.vc_tadvisor_exits_id}/>
                                </div>
                            </section>
                        </main>
                    </div>                    
                </div>
            </Layout>
        </>
    )
}

export default Advisor
